import styled from "styled-components";

export const NewIngredientsWrap = styled.div`
    .delete-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
    }
    .btn-holder {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        @media (min-width: 575px) {
            flex-direction: row;
        }
        .add-btn,
        .save-btn {
            width: 100%;
            button {
                width: 100%;
            }
        }
    }
`;
